import { baseService } from "./base";

/*
 * Service for interacting with paginated full device models.
 */
export const fullDeviceService = {
  load(params = {}, options = {}) {
    return baseService.get("/api/devices/v2", params, options);
  },

  fetch(deviceId: string, params = {}, options = {}) {
    return baseService.get(`/api/device/v2/${deviceId}`, params, options);
  },
};

export default fullDeviceService;
